// 口座開設パラメータ復元用のlocalStrageキー
export const OpenAccountParamKey = 'openAccountParam';
